import { IoIosArrowBack } from "react-icons/io";
import { Link } from "react-router-dom";
import './index.css';

export default function LinkBack({to = '/inicio/', text = 'Volver a inicio'}) {
    return (
        <div className="btn-back-navigate">
            <Link to={to} className="link-btn-svg">
                <IoIosArrowBack className="btn-back-icon" />
            </Link>
            <span className="textLink">{text}</span>
        </div>
    );
}